export class CommonMessage {
    public static tabsMessage = 'Reached maximum (5) tabs limit! Close existing tab(s)';
    public static tabsTicketOrderMessage = 'Reached maximum (4) tabs limit! Close existing tab(s)';
    public static noPermissionMessage = 'You don\'t have access to view.';
    public static clearFormData = 'Are you sure you want to clear?';
    public static attachmentMessage = "Reached Maximum (5) File attachments limit!";
    public static noCloseTicketPermissionMessage = "You can close the ticket only when ticket is assigned to you!";
    public static noReopenTicketPermissionMessage = "You can reopen the ticket only when ticket is assigned to you!";
    public static activateMessage = "Are you sure you want to Activate?"
    public static deactivateMessage = "Are you sure you want to Deactivate?";
    public static noPermissionToCloseMessage = 'You don\'t have access to Close the ticket.';
    public static noPermissionToReOpenMessage = 'You don\'t have access to Re-Open the ticket.';

    
}


// WEBPACK FOOTER //
// ./src/app/customerservice/common/common-messages.ts